/* eslint-disable */
import axios from 'axios'
import jwt_decode from 'jwt-decode';
import router from '../../Routes';

const baseUrl = process.env.VUE_APP_BASE_API + '/user/token/'

// Auth module
const state = {
  jwt: localStorage.getItem('t'),
  username: localStorage.getItem('username')
}

const mutations = {
  updateToken(state, newToken) {
    localStorage.setItem('t', newToken)
    state.jwt = newToken;
    const userData = jwt_decode(newToken);
    state.username = userData.username;
    localStorage.setItem('username', userData.username);
    // Actualizamos por defecto el token en la cabecera de las peticiones
    axios.defaults.headers.common['Authorization'] = 'JWT ' + localStorage.getItem('t');
    if (window.localStorage.getItem('t') !== null) {
      router.push('/app/dashboard').catch(err => { })
    }
  },
  removeToken(state) {
    localStorage.removeItem('t');
    state.jwt = null;
  }
}

const actions = {

  obtainToken({
    commit
  }, loginData) {
    axios.post(baseUrl, loginData)
      .then((response) => {
        commit('updateToken', response.data.token);
        router.push('/app/dashboard').catch(err => { })
      })
      .catch((error) => {
        this._vm.$notify({
          group: "foo",
          title: "Error",
          text: error.response.data.non_field_errors[0],
          type: 'danger'
        });
      })
  },
  refreshToken() {
    const payload = {
      token: this.state.jwt
    }
    axios.post(baseUrl + 'refresh', payload)
      .then((response) => {
        this.commit('updateToken', response.data.token)
      })
      .catch((error) => {
        console.log(error)
      })
  },
  inspectToken({
    state }, ) {
    const token = state.jwt;
    if (token) {
      const decoded = jwt_decode(token);
      const exp = decoded.exp
      const orig_iat = decoded.orig_iat
      if (exp - (Date.now() / 1000) < 1800 && (Date.now() / 1000) - orig_iat < 84600) {
        this.dispatch('refreshToken')
      } else if (exp - (Date.now() / 1000) < 1800) {
        // No hacer nada        
      } else {
        // Re-login
        window.localStorage.removeItem('t');
      }
    }
  },
  verifyToken(fc) {
    const token = state.jwt;
    if (token) {
      axios.post(baseUrl + 'verify/', { token })
        .then(() => fc(true))
        .catch(() => {
          fc(false);
          window.localStorage.removeItem('t');
        })
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}